export const SET_FULL_RESPOSTA_RAPIDA = "SET_FULL_RESPOSTA_RAPIDA"
export const ADD_MENSAGEM_RAPIDA = "ADD_MENSAGEM_RAPIDA"
export const REMOVE_MENSAGEM_RAPIDA = "REMOVE_MENSAGEM_RAPIDA"
export const ALTERA_RESPOSTA_RAPIDA = "ALTERA_RESPOSTA_RAPIDA"